import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerEqu1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  // const a252505 = autorizacUA.findIndex( autorizac => autorizac === "252505" );
  const a252510 = autorizacUA.findIndex( autorizac => autorizac === "252510" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {/* {a252505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      } */}
      {a252510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <Divider inverted />
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerEqu1
